import { axiosInstance } from '../common/api';

export const getProjectLabels = (projectId) => {
  const url = `/label?projectId=${projectId}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const createProjectLabel = (data) => {
  const url = `/label`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const updateProjectLabel = (labelId, data) => {
  const url = `/label/${labelId}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const deleteProjectLabel = (labelId) => {
  const url = `/label/${labelId}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
